// Import the functions you need from the SDKs you need (npm-installed SDK)
import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider, FacebookAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getAnalytics } from 'firebase/analytics';

// Prefer a runtime-injected config (via a <script> tag in index.html) so builds
// can remain generic. Fall back to environment variables or sensible defaults.
const runtimeConfig = (typeof window !== 'undefined' && window.__FIREBASE_CONFIG__) ? window.__FIREBASE_CONFIG__ : null;

// Your web app's Firebase configuration. These defaults are safe fallbacks but
// in production prefer injecting `window.__FIREBASE_CONFIG__` at runtime.
const firebaseConfig = runtimeConfig || {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyBTAXAlcAjCIE8m6-hmbSUL5s1cvSS5ksA",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "tlcweb-92094.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "tlcweb-92094",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "tlcweb-92094.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "543277322809",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:543277322809:web:3bad6c00a96417448273e8",
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "G-NLKVK6ZGT0",
};

// Small runtime helper to check if the firebase config looks valid
export function isFirebaseConfigValid() {
  const key = firebaseConfig?.apiKey;
  if (!key || typeof key !== 'string') return false;
  if (key.includes('YOUR_API_KEY')) return false;
  // basic length sanity check for API key
  return key.length > 20;
}

// Initialize Firebase only when config looks valid. This prevents the SDK from
// starting background listeners (which cause Firestore Listen RPCs) when the
// API key / config is missing or intentionally disabled in certain builds.
let app = null;
let authInstance = null;
let dbInstance = null;
let analyticsInstance = null;

const firebaseEnabled = (typeof process !== 'undefined' && process.env && process.env.REACT_APP_FIREBASE_ENABLED) ? String(process.env.REACT_APP_FIREBASE_ENABLED).toLowerCase() !== 'false' : true;

if (firebaseEnabled && isFirebaseConfigValid()) {
  try {
    app = initializeApp(firebaseConfig);
    authInstance = getAuth(app);
    dbInstance = getFirestore(app);
    // Analytics is only available in browsers. Guard to avoid server-side errors.
    try {
      if (typeof window !== 'undefined' && typeof document !== 'undefined' && firebaseConfig.measurementId) {
        analyticsInstance = getAnalytics(app);
      }
    } catch (anErr) {
      // non-fatal: analytics may fail in some environments (e.g. if cookies are blocked)
      console.debug('[firebase] analytics init skipped:', anErr?.message || anErr);
      analyticsInstance = null;
    }
  } catch (e) {
    // If initialization fails, keep instances null and surface debug info
    console.error('[firebase] initialization failed:', e?.message || e);
    app = null;
    authInstance = null;
    dbInstance = null;
  }
} else {
  if (!firebaseEnabled) {
    console.warn('[firebase] disabled via REACT_APP_FIREBASE_ENABLED=false — skipping initializeApp()');
  } else {
    console.warn('[firebase] config invalid or missing — skipping initializeApp()');
  }
}

export const auth = authInstance;
export const db = dbInstance;
export const analytics = analyticsInstance;
export const appInstance = app;
export const googleProvider = new GoogleAuthProvider();
export const facebookProvider = new FacebookAuthProvider();

// Runtime debug: expose masked config info to help diagnose Listen RPC 400s
try {
  const maskedProject = (firebaseConfig?.projectId || '').replace(/.(?=.{2})/g, '*');
  console.debug('[firebase] init status — project:', maskedProject, 'apiKeyValid:', isFirebaseConfigValid(), 'initialized:', !!app);
} catch (e) {
  // swallow in case console isn't available in some environments
}
